import { render, staticRenderFns } from "./VaultListItem.vue?vue&type=template&id=bfa2c5fa&"
import script from "./VaultListItem.vue?vue&type=script&lang=ts&"
export * from "./VaultListItem.vue?vue&type=script&lang=ts&"
import style0 from "./VaultListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports